function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#hex-community_svg__clip0_2_292)"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.218,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M35.264.625l34.31 19.81v39.618l-34.31 19.809L.953 60.052V20.435L35.263.625z",
  fill: "#0043C5"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.343,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M44.26 5.47l29.516 16.954v33.91L44.26 73.287 14.743 56.333v-33.91L44.26 5.47z",
  fill: "#0043C5"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M55.332 10.66L80.953 25.45v29.584l-25.62 14.792-25.621-14.792V25.451l25.62-14.792z",
  fill: "#0043C5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.779 36.957a3.117 3.117 0 003.114-3.114 3.117 3.117 0 00-3.114-3.115 3.117 3.117 0 00-3.114 3.114 3.117 3.117 0 003.114 3.115zm21.799 0a3.117 3.117 0 003.114-3.114 3.117 3.117 0 00-3.114-3.115 3.117 3.117 0 00-3.114 3.114 3.117 3.117 0 003.114 3.115zm1.774 1.384h-3.07c-.845 0-1.608.346-2.164.907a7.138 7.138 0 013.602 5.338c-.237.911-.237 1.367 0 1.367.466 0 1.522-.456 3.167-1.367.849 0 1.535-.698 1.535-1.561v-1.562c0-1.722-1.377-3.122-3.07-3.122zm-12.674 0a5.36 5.36 0 005.364-5.364 5.36 5.36 0 00-5.364-5.363 5.36 5.36 0 00-5.363 5.363 5.36 5.36 0 005.363 5.364zm3.91 1.73h-.404a7.678 7.678 0 01-3.333.777 7.694 7.694 0 01-3.333-.777h-.404c-3.094 0-5.605 2.505-5.605 5.593v1.398a2.334 2.334 0 002.336 2.33c3.102 2.321 5.437 3.481 7.006 3.481 1.545 0 3.88-1.16 7.007-3.48a2.334 2.334 0 002.336-2.33v-1.399c0-3.088-2.511-5.593-5.606-5.593zm-11.003-.484a3.048 3.048 0 00-2.164-.9h-3.07c-1.693 0-3.07 1.388-3.07 3.096v1.548a1.54 1.54 0 001.535 1.548c1.735.947 2.79 1.42 3.161 1.42.33 0 .33-.474 0-1.42a7.094 7.094 0 013.608-5.292z",
  fill: "#fff"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "hex-community_svg__clip0_2_292"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(.953)",
  d: "M0 0h80v80H0z"
})));

function SvgHexCommunity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgHexCommunity;